import React from 'react'

const AudioIconSvg = ({ fillColor, size }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1467_12135)">
        <path opacity="0.21" d="M32.39 0C40.7423 0 47.5133 6.865 47.5133 15.3333V32.1432C47.5133 40.6116 40.7423 47.4765 32.39 47.4765H15.1233C6.77096 47.4765 0 40.6116 0 32.1432V15.3333C2.22774e-06 6.865 6.77096 0 15.1233 0H32.39Z" fill="#A4A2FF" fill-opacity="0.4" />
        <mask id="mask0_1467_12135" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="11" y="12" width="25" height="24">
          <path d="M35.5069 12H11.8356V36H35.5069V12Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1467_12135)">
          <path d="M31.5616 34.5H15.7808V13.5H26.6301L31.5616 18.5V34.5Z" fill="#90CAF9" />
          <path d="M30.8219 19H26.137V14.25L30.8219 19Z" fill="#E1F5FE" />
          <path d="M23.1781 29C24.2676 29 25.1507 28.1046 25.1507 27C25.1507 25.8954 24.2676 25 23.1781 25C22.0886 25 21.2055 25.8954 21.2055 27C21.2055 28.1046 22.0886 29 23.1781 29Z" fill="#1976D2" />
          <path d="M26.6302 22.5L24.1644 21.5V27H25.1507V23.45L26.6302 24V22.5Z" fill="#1976D2" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1467_12135">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default AudioIconSvg